import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { LanguageProvider } from "./features/LanguageContext";
import ErrorBoundary from "./features/ErrorBoundary";
console.log(window, document);
let persistor = persistStore(store);
const language = 'cs'; // Nastavenie češtiny ako jazyka pre celú aplikáciu
ReactDOM.render(
  <React.StrictMode>
    <div lang={language}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ErrorBoundary><App /></ErrorBoundary>
        </PersistGate>
      </Provider>
    </div>
  </React.StrictMode>,
  document.getElementById("root")
);
